import { render, staticRenderFns } from "./Charpter_tree.vue?vue&type=template&id=5cf90876&scoped=true&"
import script from "./Charpter_tree.vue?vue&type=script&lang=js&"
export * from "./Charpter_tree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf90876",
  null
  
)

export default component.exports